import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import {
  CategoryMultiSelect,
  CategorySelectFormikField,
} from '../../../../Category'
import { PROVIDER_FORM_FIELD_NAME_CATEGORY } from '../../ProviderForm.constants'

import * as styles from './CategoryField.module.css'

function CategoryField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <CategorySelectFormikField
      multi
      Select={CategoryMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Provider.СategoryFieldPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Provider.СategoryFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={PROVIDER_FORM_FIELD_NAME_CATEGORY}
      tagsProps={{
        className: styles.categoryFieldTags,
      }}
    />
  )
}

export default CategoryField
